/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import SDK from '../SDK';
import {EncodedEdgeToken} from '../../edgeAuth/EncodedEdgeToken';
import Publisher from './Publisher';

type CreatePublisherOptions = {
  mediaStream: MediaStream;
  token: EncodedEdgeToken;
  name?: string;
};

export default class Publishers {
  static createPublisher(options: CreatePublisherOptions): Publisher {
    if (!SDK.initialized.value) {
      throw new Error('SDK is not loaded.');
    }

    return new Publisher(options.mediaStream, options.token, options.name);
  }

  private constructor() {
    throw new Error('Publishers is a static class that may not be instantiated');
  }
}